import { Injectable } from '@angular/core';

export class BuildDetails {
    buildNumber!: string;
    WMSVersionMessage?: string;
    RepVersionMessage?: string;

    backendLogging!: {
        _?: {
            User?: {
                [key: string]: number
            }
        },
        TransferPutaway: {
            Level: number,
            User?: {
                [key: string]: number
            }
        }
    }
}

@Injectable({ providedIn: 'root' })
export class BuildDetailsService {
    public buildDetails: BuildDetails;

    constructor() {
        this.buildDetails = new BuildDetails();
    }
}